import { useMutation } from '@tanstack/react-query';
import { changePasswordApi, ChangePasswordRequest, ChangePasswordResponse } from '@/api/auth';

export const useChangePassword = () => {
  return useMutation<ChangePasswordResponse, Error, ChangePasswordRequest>({
    mutationFn: (data: ChangePasswordRequest) => changePasswordApi(data),
  });
};
